import * as actions from "../action.constants";

const toggleModal = (modal, callback) => ({
  type: actions.TOGGLE_MODAL,
  modal,
  callback,
});

const getOrganizationAddress = () => ({
  type: actions.REQUEST_ORGANIZATION_ADDRESS,
});

const storeOrganizationAddress = (data) => ({
  type: actions.STORE_ORGANIZATION_ADDRESS,
  payload: data,
});

const requestScope = (callback, customerId) => ({
  type: actions.REQUEST_SCOPE,
  callback,
  customerId,
});

const storeScope = (data) => ({
  type: actions.STORE_SCOPE,
  payload: data,
});

const requestControllersForScope = (payload, callback) => ({
  type: actions.REQUEST_CONTROLLERS_FOR_SCOPE,
  payload,
  callback,
});

const storeControllersForScope = (data) => ({
  type: actions.STORE_CONTROLLERS_FOR_SCOPE,
  payload: data,
});

export {
  toggleModal,
  getOrganizationAddress,
  storeOrganizationAddress,
  requestScope,
  storeScope,
  requestControllersForScope,
  storeControllersForScope,
};
